// ── ردیابی سبک بازدید/اکشن (Analytics) ────────────────────────────────────
// این فایل عمداً بدون هیچ کتابخانه‌ی خارجی نوشته شده (نه Google Analytics، نه
// چیز دیگری از بیرون) — فقط با visitorId/sessionId خودش و endpoint اختصاصی
// /t/e سرور صحبت می‌کند. هدف: بفهمیم هر بازدیدکننده از کجا آمده (پیامک دعوت،
// گوگل، لینک رفرال یک کاربر دیگر، یا مستقیم) و در سایت چه‌کار کرد — کاملاً
// روی سرور خودمان، بدون سرویس بیرونی.
import Cookies from 'js-cookie';

const VISITOR_KEY = 'ph_visitor_id';
const FIRST_TOUCH_KEY = 'ph_first_touch';
const SESSION_KEY = 'ph_session_id';

function uuid() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = uuid();
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return 'no-storage';
  }
}

function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = uuid();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return 'no-storage';
  }
}

/**
 * فقط یک‌بار (اولین باری که این مرورگر دیده می‌شود) سیگنال‌های خام ورود را
 * capture و ذخیره می‌کند — بعدها دیگر هیچ‌وقت بازنویسی نمی‌شود، حتی اگر
 * کاربر بعداً از لینک دیگری دوباره سر بزند، چون «اولین باری که آمد» همانی
 * است که سرور برای attribution ثبت‌نام استفاده می‌کند.
 */
function captureFirstTouchIfNeeded() {
  try {
    if (localStorage.getItem(FIRST_TOUCH_KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const firstTouch = {
      referrer: document.referrer || null,
      landingPath: window.location.pathname,
      utmSource: params.get('utm_source') || null,
      utmMedium: params.get('utm_medium') || null,
      utmCampaign: params.get('utm_campaign') || null,
      hasInviteCode: !!params.get('code'),
      hasReferralCode: !!(params.get('ref') || params.get('referralCode')),
      capturedAt: new Date().toISOString()
    };
    localStorage.setItem(FIRST_TOUCH_KEY, JSON.stringify(firstTouch));
  } catch {
    // localStorage در دسترس نیست (مثلاً حالت ناشناس با محدودیت) — مهم نیست،
    // فقط یعنی attribution آن بازدید به 'unknown' می‌افتد.
  }
}

function getFirstTouch() {
  try {
    const raw = localStorage.getItem(FIRST_TOUCH_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

const TRACK_BASE = (process.env.REACT_APP_API_URL || '/api').replace(/\/api\/?$/, '');
const TRACK_URL = `${TRACK_BASE}/t/e`;

function send(payload) {
  try {
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      const ok = navigator.sendBeacon(TRACK_URL, blob);
      if (ok) return;
    }
    fetch(TRACK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true
    }).catch(() => {});
  } catch {
    // آمار هیچ‌وقت نباید تجربه‌ی کاربر را بشکند
  }
}

function track(type, { path, action, meta } = {}) {
  captureFirstTouchIfNeeded();
  const firstTouch = getFirstTouch();
  send({
    visitorId: getVisitorId(),
    sessionId: getSessionId(),
    type,
    path: path || window.location.pathname,
    action: action || null,
    meta: meta || null,
    referrer: firstTouch?.referrer || null,
    signals: firstTouch || {},
    token: Cookies.get('token') || null
  });
}

export const tracker = {
  getVisitorId,
  getFirstTouch,
  trackPageview: (path) => track('pageview', { path }),
  trackAction: (action, meta) => track('action', { action, meta })
};

export default tracker;
